import { login } from '@edu-fe/login'
import api from './api'
import { pick } from './utils'

/**
 * 微信内下单接口
 *
 * @param {Object} params 参数
 * @param {String} params.couponId 优惠券id
 * @param {String} params.courseId 商品id
 * @param {String} params.groupId 参团id
 * @param {Number} params.payWay 下单方式, 9:支付宝 | 10:微信支付
 * @param {String} params.from 订单来源
 * @param {Number} params.isSend 是否是赠送, 1:是 | 0:不是
 * @param {Number} params.theme 赠送主题
 * @param {Number} params.type 商品类型, 1:课程 | 2:专题
 * @param {String} params.wpsSid 用户id
 * @param {String} params.thirdSession 小程序用户信息
 * @param {String} params.token 分享唯一标示
 * @return {Promise} 接口返回信息 { giftId }
 */
function getAuthCode () {
  return new Promise ((resolve, reject) => {
    my.postMessage({'pay': true})

    my.onMessage = ({ authCode }) => {
      if (!authCode) {
        my.alert({
          content: '授权失败，请重新授权！'
        })
        reject('fail')
      }
      resolve({ authCode })
    }
  })
}
export default async function pay (params) {
  const { authCode } = await getAuthCode()
  const { code, data, msg } = await api.PackageEduFePay.ali({
    ...params,
    authCode
  })
  if (code < 0) {
    return login().then(() => params)
  }
  my.tradePay({
    tradeNO: data, // 调用统一收单交易创建接口（alipay.trade.create），获得返回字段支付宝交易号trade_no
    success: ({ resultCode }) => {
      if (resultCode === 6001) {
        params.cancelCallback()
      }
    },
    fail: () => {
      params.failCallback()
    }
  });
  return { orderId: msg }
}
